<button type="button" mat-icon-button 
    color="primary"
    class="hidden-print commandbar-item material-icons"
    (click)="printPage()"
    tooltip-placement="bottom" tooltip="Print" title="Print"
    id="buttonPrint"
    aria-label="Print document">
    <mat-icon>print</mat-icon>
</button>